function numberToWords(num) {
  const unites1 = [
    "",
    "un",
    "deux",
    "trois",
    "quatre",
    "cinq",
    "six",
    "sept",
    "huit",
    "neuf",
  ];
  const unites2 = [
    "dix",
    "onze",
    "douze",
    "treize",
    "quatorze",
    "quinze",
    "seize",
    "dix-sept",
    "dix-huit",
    "dix-neuf",
  ];
  const dizaines = [
    "",
    "",
    "vingt",
    "trente",
    "quarante",
    "cinquante",
    "soixante",
    "soixante",
    "quatre-vingt",
    "quatre-vingt",
  ];
  const scales = ["", "mille", "million", "milliard"];

  const chunkify = (n) => {
    let chunks = [];
    let numStr = String(n);
    while (numStr.length > 0) {
      chunks.unshift(numStr.slice(-3));
      numStr = numStr.slice(0, -3);
    }
    return chunks;
  };

  const convertChunk = (chunk) => {
    let number = parseInt(chunk, 10);
    if (number === 0) return "";

    let words = [];
    if (number >= 100) {
      let hundreds = Math.floor(number / 100);
      if (hundreds === 1) words.push("cent");
      else words.push(unites1[hundreds] + " cent");
      if (number % 100 === 0 && hundreds > 1) words[words.length - 1] += "s";
      number = number % 100;
    }

    if (number >= 10 && number < 20) {
      words.push(unites2[number - 10]);
    } else if (number >= 20) {
      let tens = Math.floor(number / 10);
      let unit = number % 10;

      if (tens === 7 || tens === 9) {
        words.push(
          dizaines[tens] + (unit === 1 ? " et " : "-") + unites2[unit]
        );
      } else {
        let join =
          unit === 1 && (tens === 1 || tens === 2)
            ? " et "
            : unit > 0
            ? "-"
            : "";
        words.push(dizaines[tens] + join + (unit > 0 ? unites1[unit] : ""));
      }
    } else if (number > 0) {
      words.push(unites1[number]);
    }

    return words.join(" ");
  };

  // Split number
  let [intPart, decimalPart = ""] = String(num).split(".");
  decimalPart = decimalPart.padEnd(3, "0").substring(0, 3); // force 3-digit millimes

  // Convert integer part
  let chunks = chunkify(intPart);
  let words = [];
  for (let i = 0; i < chunks.length; i++) {
    const chunkWords = convertChunk(chunks[i]);
    if (chunkWords) {
      let scale = scales[chunks.length - i - 1];
      if (scale === "mille" && chunkWords === "un") {
        words.push("mille");
      } else {
        words.push(chunkWords + (scale ? " " + scale : ""));
      }
    }
  }

  words.push("dinars");

  // Convert millimes as full 3-digit number
  const millimeWords = convertChunk(decimalPart);
  if (parseInt(decimalPart) > 0) {
    words.push("et");
    words.push(millimeWords + " millimes");
  }

  let result = words.join(" ").replace(/\s+/g, " ").trim();
  return result.charAt(0).toUpperCase() + result.slice(1);
}

export default numberToWords;
